import { AfterViewInit, ChangeDetectorRef, Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ConfigProvider } from "../../../config-provider.service";
import { AuthComponent } from "../../components/auth/auth/auth";
import { TranslateService } from "@ngx-translate/core";
import { CurrentUser } from "../../providers/current-user";
import { BreadcrumbProvider } from "../../../breadcrumb/providers/breadcrumb-provider";
import { Organization } from "../../models/organization";
import { FullScreenLoaderComponent } from "../../components/full-screen-loader/full-screen-loader";
import { isPlatformBrowser, NgIf } from "@angular/common";
import { timeout } from "rxjs";
import { Element } from "@angular/compiler";

@Component({
  selector: 'home-page',
  providers: [],
  styleUrls: ['./home.scss'],
  standalone: true,
  imports: [
    AuthComponent,
    FullScreenLoaderComponent,
    NgIf,
  ],
  templateUrl: './home.html'

})
export class HomePageComponent implements AfterViewInit {
    public organizations: Organization[] = [];

    constructor(
        public conf: ConfigProvider,
        public currentUser: CurrentUser,
        public breadcrumbProvider: BreadcrumbProvider,
        private title: Title,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private changeDetectorRef: ChangeDetectorRef,
        private translateService: TranslateService,
        @Inject(PLATFORM_ID) private platformId: Object,
    ) {
    }

    public ngAfterViewInit() {
        this.title.setTitle(this.conf.platformName);
        this.breadcrumbProvider.setDefaultCrumbs([]);
        if (this.currentUser.isLoggedIn()) {
            this.tryRedirect();
        }
        if (! this.currentUser.retrieveAccessToken() &&  isPlatformBrowser(this.platformId)) {
          // comme le *ngIf ou le [hidden] d'Angular ne fonctionne pas lors du reload manuel de la page
          // j'ai du ajouter ce code pour cacher le loader et afficher le formulaire de login via les classNames
          // c'est pas ultra propre mais ça fait le job, je n'ai pas trouvé d'autres solutions

          const fullScreenLoaderModule = document.getElementById('full-screen-loader');
          const authModule = document.getElementById('auth-module');
          // remove loader and show login form
          if (fullScreenLoaderModule) {
            fullScreenLoaderModule.classList.add('hidden');
          }
          if (authModule) {
            authModule.classList.remove('hidden');
            authModule.classList.add('show');
          }
        }

        this.changeDetectorRef.detectChanges();
    }

    private tryRedirect(): void {
        // si l'utilisateur a plusieurs organizations (ou aucune)
        // on lui propose de choisir parmi l'un d'entre eux (ou d'en créer une)
        // // sinon on le redirige vers sa organization
        // this.api.call('get', '/organizations', {
        //   userId: this.currentUser.user.id
          // orderBy: 'name'
        // }, this.currentUser.getAccessToken())
        // this._storage.select(Organization)
        //     .where('id').equals(OrganizationMembership, 'organizationId')
        //     .and('userId', OrganizationMembership).equals(this.currentUser.user.id)
        //     .orderBy('name')
        //     .get()
        //     .then((organizations: Organization[]) => {
        //         if (organizations.length === 1) {
        //             this.router.navigate([organizations[0].code]);
        //         } else {
        //             this.organizations = organizations;
        //         }
        //     })
        //     .catch((error: any) => this.onError(error));
    }

    private onError(error: any): void {
      console.error("pages/home", error);
    }
}
